import { render, staticRenderFns } from "./ChannelPublicationEditor.vue?vue&type=template&id=73043f15&scoped=true&lang=pug&"
import script from "./ChannelPublicationEditor.vue?vue&type=script&lang=js&"
export * from "./ChannelPublicationEditor.vue?vue&type=script&lang=js&"
import style0 from "./ChannelPublicationEditor.vue?vue&type=style&index=0&id=73043f15&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73043f15",
  null
  
)

export default component.exports